// The closed lists a standard is described with.
//
// Taken from the create-standard form so the wizard offers exactly the same
// choices. They are closed lists on purpose: a cable type or a colour typed by
// hand is how the material catalogue ended up with `NATUR` and `NATURA`, and
// these particular values are part of the key that identifies a standard —
// `GREY` and `GREY 7004` are different products, `Grey` is a lookup that fails.
//
// The value is what gets stored; the label is Romanian, as on the shop floor.

export const CABLE_NAMES = ['CYYF', 'CYABYF', 'N2XH', 'MYYM', 'RVK', 'MYYUP', 'MYF', 'FY'];

/** Cables whose insulated conductor IS the finished product. */
export const SINGLE_CONDUCTOR_NAMES = ['FY', 'MYF'];

export const SHEATH_COLORS = [
  { value: 'WHITE', label: 'ALB' },
  { value: 'BLACK', label: 'NEGRU' },
  { value: 'GREY', label: 'GRI' },
  { value: 'GREY 7004', label: 'GRI 7004' }
];

export const CONDUCTOR_COLORS = [
  { value: 'GREEN-YELLOW', label: 'VERDE-GALBEN' },
  { value: 'BROWN', label: 'MARO' },
  { value: 'BLUE', label: 'ALBASTRU' },
  { value: 'BLACK', label: 'NEGRU' },
  { value: 'GREY', label: 'GRI' },
  { value: 'RED', label: 'ROSU' },
  { value: 'WHITE', label: 'ALB' }
];

export const WIRE_MATERIALS = [
  { value: 'COPPER', label: 'Cupru' },
  { value: 'ALUMINIUM', label: 'Aluminiu' }
];

export const WIRE_TYPES = [
  { value: 'STRANDED', label: 'Trefilat' },
  { value: 'SINGLE-WIRE', label: 'Fir solid' },
  { value: 'MULTI-WIRE', label: 'Multi-fir solid' }
];
